import React from "react";

interface CircleProgressProps {
  size?: number;
  thickness?: number;
  progress: number;
  doneColor?: string;
  restColor?: string;
}

const CircleProgress: React.FC<CircleProgressProps> = ({
  size = 100,
  thickness = 3,
  progress,
  doneColor = "#3F4067",
  restColor = "#E4E4F2",
}) => {
  const radius = (size - thickness) / 2;
  const circumference = 2 * Math.PI * radius;

  // Bal oldaltól (9 órától) induló, lefelé CCW progress
  const offset = circumference * (1 - progress / 100) * -1;

  return (
    <svg width={size} height={size}>
      {/* Háttér gyűrű */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={restColor}
        strokeWidth={thickness}
        fill="none"
      />

      {/* Előrehaladás */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={doneColor}
        strokeWidth={thickness}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-180 ${size / 2} ${size / 2})`}
        style={{ transition: "stroke-dashoffset 0.3s linear" }}
      />
    </svg>
  );
};

export default CircleProgress;